import { useMemo } from 'react';
import { useSearchParams } from 'react-router-dom';

import { ChatWidget } from '@/widgets/chat';

export function Chat() {
  const [params] = useSearchParams();
  const initialPrompt = useMemo(() => params.get('prompt') ?? '', [params]);

  return (
    <div className="space-y-4">
      <header className="space-y-1">
        <h1 className="font-display text-4xl tracking-wide text-ugin-text">Chat</h1>
        <p className="text-sm text-ugin-text-muted">
          Ask Ugin anything — meta, decks, matchups, brews.
        </p>
      </header>
      <ChatWidget fullPage initialPrompt={initialPrompt} />
    </div>
  );
}
